import request from "@/utils/request";

// 首页获取banner
export function fetchbannerList(data) {
  return request({
    url: "/rest/banner/list",
    method: "post",
    data
  });
}

// 首页查询新闻报道列表信息
export function fetchNewsReportList(data) {
  return request({
    url: "/rest/newsReport/list",
    method: "post",
    data
  });
}


// 新闻详情
export function fetchNewsDetail(id,data) {
  return request({
    url: `/rest/newsReport/detail/${id}`,
    method: "get",
    data
  });
}
// 患者专区详情
export function fetchPatientStoryDetail(id,data) {
  return request({
    url: `/rest/patientStory/detail/${id}`,
    method: "get",
    data
  });
}


// 新闻详情的左侧推荐
export function fetchNewsRecommendList(data) {
  return request({
    url: "/rest/newsReport/recommendList",
    method: "post",
    data
  });
}

// 荣誉专区
export function fetchHonorList(data) {
  return request({
    url: "/rest/honnor/list",
    method: "post",
    data
  });
}

// 患者故事
export function fetPatientStoryList(data) {
  return request({
    url: "/rest/patientStory/list",
    method: "post",
    data
  });
}

// 岗位
export function fetJobList(data) {
  return request({
    url: "/rest/job/list",
    method: "post",
    data
  });
}
// 获取联系我们数据
export function fetUserData(data) {
  return request({
    url: "/rest/contactInformation/find",
    method: "post",
    data
  });
}

export function fetchSearchData(data) {
  return request({
    url: "/rest/newsReport/query",
    method: "post",
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/index.js